export default __webpack_public_path__ + "static/media/bathea.5155159e.webp";